<template>
    <div class="cadryer-main">
        <Row :gutter="15">
            <Col span="8">
                <Card style="margin-bottom:15px;" :bordered="false">
                    <p slot="title">
                        <Icon type="md-apps"/>
                        &nbsp;{{$t('baseInfo')}}
                    </p>
                    <dl class="base-dl">
                        <dt>{{$t('deviceName')}}</dt>
                        <dd>{{device.name}}</dd>
                        <dt>{{$t('deviceModel')}}</dt>
                        <dd>{{device.model}}</dd>
                        <dt>{{$t('deviceSerial')}}</dt>
                        <dd>{{device.order_code}}</dd>
                        <dt>{{$t('deviceRegisteTime')}}</dt>
                        <dd>{{device.created | formatTime}}</dd>
                    </dl>
                </Card>
                <Card :bordered="false">
                    <p slot="title">
                        <Icon type="md-cloudy"/>
                        &nbsp;{{$t('realTimeData')}}
                    </p>
                    <a href="javascript:;" slot="extra">
                        <Icon type="md-settings" @click="showAttrsModal"/>
                    </a>
                    <dl class="dat-dl">
                        <template v-if="attrs.sv">
                            <dt>{{$t('cadsv')}}</dt>
                            <dd>{{dat.sv|format(10, 1, '°C')}}</dd>
                        </template>
                        <template v-if="attrs.pv">
                            <dt>{{$t('cadpv')}}</dt>
                            <dd>{{dat.pv|format(10, 1, '°C')}}</dd>
                        </template>
                        <template v-if="attrs.tup">
                            <dt>{{$t('cadtup')}}</dt>
                            <dd>{{dat.tup|format(10, 1, '°C')}}</dd>
                        </template>
                        <template v-if="attrs.tlow">
                            <dt>{{$t('cadtlow')}}</dt>
                            <dd>{{dat.tlow|format(10, 1, '°C')}}</dd>
                        </template>
                        <template v-if="attrs.pup">
                            <dt>{{$t('cadpup')}}</dt>
                            <dd>{{dat.pup|format(10, 1, 'bar')}}</dd>
                        </template>
                        <template v-if="attrs.plow">
                            <dt>{{$t('cadplow')}}</dt>
                            <dd>{{dat.plow|format(10, 1, 'bar')}}</dd>
                        </template>
                        <template v-if="attrs.back">
                            <dt>{{$t('cadback')}}</dt>
                            <dd>{{dat.back|format(10, 1, '°C')}}</dd>
                        </template>
                        <template v-if="attrs.dp">
                            <dt>{{$t('caddp')}}</dt>
                            <dd>{{dat.dp|format(10, 1, '°C')}}</dd>
                        </template>
                        <template v-if="attrs.cap">
                            <dt>{{$t('cadcap')}}</dt>
                            <dd>{{dat.cap|format(10, 1, 'bar')}}</dd>
                        </template>
                        <template v-if="attrs.cadp">
                            <dt>{{$t('cadcadp')}}</dt>
                            <dd>{{dat.cadp|format(10, 1, '°C')}}</dd>
                        </template>
                        <template v-if="attrs.status">
                            <dt>{{$t('runStatus')}}</dt>
                            <dd>{{status[dat.status] ? status[dat.status] : '--'}}</dd>
                        </template>
                        <template v-if="attrs.err">
                            <dt>{{$t('runError')}}</dt>
                            <dd>{{error}}</dd>
                        </template>
                        <template v-if="attrs.time">
                            <dt>{{$t('updateTime')}}</dt>
                            <dd>{{dat.time ? dat.time : '--'}}</dd>
                        </template>
                    </dl>
                </Card>
            </Col>
            <Col span="16">
                <Row :gutter="15" style="margin-bottom:15px;">
                    <Col span="16">
                        <Card :bordered="false">
                            <p slot="title">
                                <Icon type="md-eye"/>
                                &nbsp;{{$t('watchData')}}
                            </p>
                            <div class="watch">
                                <div class="w-item">
                                    <p class="tx">{{$t('cadpv')}}(°C)</p>
                                    <p class="val">{{dat.pv|format(10, 1, '')}}</p>
                                </div>
                                <div class="w-item">
                                    <p class="tx">{{$t('cadback')}}(°C)</p>
                                    <p class="val">{{dat.back|format(10, 1, '')}}</p>
                                </div>
                                <div class="w-item">
                                    <p class="tx">{{$t('caddp')}}(°C)</p>
                                    <p class="val">{{dat.dp|format(10, 1, '')}}</p>
                                </div>
                                <div class="w-item">
                                    <p class="tx">{{$t('powerkwh')}}(kW·h)</p>
                                    <p class="val">{{dat.power|format(10, 1, '')}}</p>
                                </div>
                            </div>
                        </Card>
                    </Col>
                    <Col span="8">
                        <StatusChart :item="statusDat" :uuid="device.uuid"></StatusChart>
                    </Col>
                </Row>
                <Card :bordered="false">
                    <div slot="title">
                        <Dropdown trigger="click" @on-click="changeEchartType">
                            <p style="cursor:pointer">
                                <Icon type="md-stats"/>
                                {{$t('realTimeChart')}}-{{chartType==0?$t('temperature'):$t('pressure')}}
                                <Icon type="ios-arrow-down"></Icon>
                            </p>
                            <DropdownMenu slot="list">
                                <DropdownItem :name="0">{{$t('temperature')}}</DropdownItem>
                                <DropdownItem :name="1">{{$t('pressure')}}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div slot="extra" class="charts-radio">
                        <Poptip placement="bottom-end" v-model="historyData.showPoptip">
                            <Input v-model="historyData.inputData" icon="ios-calendar-outline" :placeholder="$t('b_timeRangeSearch')" readonly style="width: 280px"/>
                            <div slot="content">
                                <div style="padding-bottom: 10px;" class="date-select">
                                    <span class="margin-r10">{{$t('startTime')}}:</span>
                                    <DatePicker v-model="historyData.start" type="datetime" :placeholder="$t('startTime')" format="yyyy-MM-dd HH:mm:ss" style="width: 200px" @on-change="changeHistoryDate($event,'start')"></DatePicker>
                                </div>
                                <div>
                                    <span class="margin-r10">{{$t('endTime')}}:</span>
                                    <DatePicker v-model="historyData.end" type="datetime" :placeholder="$t('endTime')" format="yyyy-MM-dd HH:mm:ss" style="width: 200px" @on-change="changeHistoryDate($event,'end')"></DatePicker>
                                </div>
                                <Divider style="margin: 10px 0;"/>
                                <Button type="primary" class="margin-r10" @click="histortBtn(0)">{{$t('b_realTime')}}</Button>
                                <Button type="primary" @click="histortBtn(1)">1{{$t('b_hour')}}</Button>
                                <Button type="primary" @click="histortBtn(1)">6{{$t('b_hour')}}</Button>
                                <Button type="primary" @click="histortBtn(24)">1{{$t('b_day')}}</Button>
                                <Button type="info" @click="historySubmit">{{$t('b_makeSure')}}</Button>
                            </div>
                        </Poptip>
                    </div>
                    <div ref="echart" class="echart-line"></div>
                </Card>
            </Col>
        </Row>
        <!-- 设置显示的属性 -->
        <Modal v-model="attrsModal.show" @on-ok="doChangeAttrs" @on-cancel="attrsModal.show = false" width="600" :ok-text="$t('ok')" :cancel-text="$t('cancel')">
            <p slot="header">
                <Icon type="md-pricetag"/>
                <span>{{$t('b_setShowProperies')}}</span>
            </p>
            <div class="data-attrs clearfix">
                <Checkbox v-model="attrsModal.attrs.sv">{{$t('cadsv')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.pv">{{$t('cadpv')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.tup">{{$t('cadtup')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.tlow">{{$t('cadtlow')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.pup">{{$t('cadpup')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.plow">{{$t('cadplow')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.back">{{$t('cadback')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.dp">{{$t('caddp')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.cap">{{$t('cadcap')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.cadp">{{$t('cadcadp')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.status">{{$t('runStatus')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.err">{{$t('runError')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.time">{{$t('updateTime')}}</Checkbox>
            </div>
        </Modal>
    </div>
</template>

<script>
import StatusChart from './statuschart.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment, { now } from 'moment';
import echarts from 'echarts';

export default {
    props: {
        device: Object
    },
    components: {
        StatusChart
    },
    data() {
        return {
            datIntval: null, //实时刷新的定时器
            dat: {}, // 实时数据
            statusDat: {
                run: 0,
                stby: 0,
                alarm: 0,
                off: 0,
                stop: 0,
                status: 0
            }, // 状态饼图
            // 属性显示控制
            attrs: sessionStorage.getItem('cadryer_attrs')
                ? JSON.parse(sessionStorage.getItem('cadryer_attrs'))
                : {
                      sv: true, // 设定温度
                      pv: true, // 实际温度
                      tup: true, // 温度上限
                      tlow: true, // 温度下限
                      pup: true, // 压力上限
                      plow: true, // 压力下限
                      back: true, // 回风温度
                      dp: true, // 实际露点
                      cap: true, // 压缩空气压力
                      cadp: true, // 压缩空气露点
                      status: true, // 运行状态（0：离线，1：运行，2：待机，3：报警）
                      err: true, // 故障
                      time: true // 更新时间
                  },
            //历史数据信息
            historyData: {
                showPoptip: false,
                inputData: Moment().format('YYYY-MM-DD HH:mm:ss'),
                start: '',
                end: '',
                isHistory: false, //是不是要显示历史数据
                btnValue: 0 // 默认点击的是实时按钮
            },
            attrsModal: {
                show: false,
                attrs: {}
            }, // 实时数据显示控制
            myChart: {}, // 图表
            chartType: 0,
            // 温度图表
            tempOption: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: [this.$t('cadsv'), this.$t('cadpv'), this.$t('cadback'), this.$t('caddp'), this.$t('cadcadp')]
                },
                grid: {
                    left: 20,
                    right: 40,
                    bottom: 20,
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    },
                    right: 40
                },
                xAxis: {
                    type: 'time',
                    boundaryGap: false,
                    splitNumber:15,
                    // maxInterval: 10 * 1000 // 最多10s分割
                },
                yAxis: {
                    name: this.$t('temperature') + '(°C)',
                    type: 'value',
                    boundaryGap: ['0', '20%']
                },
                series: [
                    {
                        name: this.$t('cadsv'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('cadpv'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('cadback'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('caddp'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('cadcadp'),
                        type: 'line',
                        smooth: true,
                        data: []
                    }
                ]
            },
            // 压力图表
            pressOption: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: [this.$t('cadcap')]
                },
                grid: {
                    left: 20,
                    right: 40,
                    bottom: 20,
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    },
                    right: 40
                },
                xAxis: {
                    type: 'time',
                    boundaryGap: false,
                    splitNumber:15,
                    // maxInterval: 10 * 1000 // 最多10s分割
                },
                yAxis: {
                    name: this.$t('pressure') + '(bar)',
                    type: 'value',
                    boundaryGap: ['0', '20%']
                },
                series: [
                    {
                        name: this.$t('cadcap'),
                        type: 'line',
                        smooth: true,
                        data: []
                    }
                ]
            },
            //历史图表
            // 温度图表
            tempHistoryOption: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: [this.$t('cadsv'), this.$t('cadpv'), this.$t('cadback'), this.$t('caddp'), this.$t('cadcadp')]
                },
                grid: {
                    left: 20,
                    right: 40,
                    bottom: 20,
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    },
                    right: 40
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    name: this.$t('temperature') + '(°C)',
                    type: 'value',
                    boundaryGap: ['0', '20%']
                },
                series: [
                    {
                        name: this.$t('cadsv'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('cadpv'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('cadback'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('caddp'),
                        type: 'line',
                        smooth: true,
                        data: []
                    },
                    {
                        name: this.$t('cadcadp'),
                        type: 'line',
                        smooth: true,
                        data: []
                    }
                ]
            },
            // 压力图表
            pressHistoryOption: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: [this.$t('cadcap')]
                },
                grid: {
                    left: 20,
                    right: 40,
                    bottom: 20,
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    },
                    right: 40
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    name: this.$t('pressure') + '(bar)',
                    type: 'value',
                    boundaryGap: ['0', '20%']
                },
                series: [
                    {
                        name: this.$t('cadcap'),
                        type: 'line',
                        smooth: true,
                        data: []
                    }
                ]
            },
            status: [this.$t('stop'), this.$t('run'), this.$t('stby'), this.$t('alarm'), this.$t('off')] // 运行状态
        };
    },
    computed: {
        error() {
            let err1 = ['干燥温度感应器线断', '回气温度感应器线断', '温度高报警', '温度低报警', '压力高报警', '压力低报警', '压力感应器线断', '露点感应器线断', '温度过高报警（超温保护器动作）', '压缩空气压力低报警', '加热失效报警', '干燥温度校准错误', '回气温度校准错误', '压力校准错误', '露点校准措误', ''];
            // let err2 = ['进水水压低', '禁用', '增压泵过载', '首次温度过高', '首次温度过低', '系统压力高', '液温高', '', '', '', '', '', '', '', '', ''];
            let err = [].concat(
                err1.filter((item, index) => {
                    return ((this.dat.err1 >> index) & 1) == 1;
                })
            );
            if (err.length > 0) {
                return err.join(',');
            }
            return '--';
        }
    },
    mounted() {
        // 图表初始化
        let dom = this.$refs.echart;
        this.myChart = echarts.init(dom);
        // 初始化原始数据
        let now = Moment().unix();
        for (let i = 60; i > 0; i--) {
            this.tempOption.series[0].data.push([(now - i) * 1000, '-']);
            this.tempOption.series[1].data.push([(now - i) * 1000, '-']);
            this.tempOption.series[2].data.push([(now - i) * 1000, '-']);
            this.tempOption.series[3].data.push([(now - i) * 1000, '-']);
            this.tempOption.series[4].data.push([(now - i) * 1000, '-']);
            this.pressOption.series[0].data.push([(now - i) * 1000, '-']);
        }
        this.myChart.setOption(this.tempOption);
        this.getRealTime();
        this.datIntval = setInterval(() => {
            this.historyData.inputData = Moment().format('YYYY-MM-DD HH:mm:ss');
            this.getRealTime();
        }, 3000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(this.datIntval);
        });
    },
    methods: {
        // 获取实时数据
        getRealTime() {
            Axios.get(AxiosUrl.device.currentdata, {
                params: {
                    serial: this.device.uuid
                }
            })
                .then(res => {
                    let {
                        code,
                        data: { data: dat, time }
                    } = res.data;
                    if (code == 200) {
                        this.dat = JSON.parse(dat);
                        this.dat.time = time;
                        // 判断超时 15s
                        if (time == '' || Moment().unix() > Moment(time, 'YYYY-MM-DD HH:mm:ss').unix() + 300) {
                            this.dat.status = 4; // 离线
                            this.statusDat.status = 4; // 离线
                            this.dat.sv = '--';
                            this.dat.pv = '--';
                            this.dat.tup = '--';
                            this.dat.tlow = '--';
                            this.dat.pup = '--';
                            this.dat.plow = '--';
                            this.dat.back = '--';
                            this.dat.dp = '--';
                            this.dat.cap = '--';
                            this.dat.cadp = '--';
                            this.dat.err1 = 0;
                            this.dat.power = '--';
                        }
                        this.updateChart();
                    }
                })
                .catch(error => {});
        },
        // 更新图表
        updateChart() {
            let now = Moment().unix() * 1000;
            this.tempOption.series[0].data.shift();
            this.tempOption.series[0].data.push([now, this.dat.sv / 10]);
            this.tempOption.series[1].data.shift();
            this.tempOption.series[1].data.push([now, this.dat.pv / 10]);
            this.tempOption.series[2].data.shift();
            this.tempOption.series[2].data.push([now, this.dat.back / 10]);
            this.tempOption.series[3].data.shift();
            this.tempOption.series[3].data.push([now, this.dat.dp / 10]);
            this.tempOption.series[4].data.shift();
            this.tempOption.series[4].data.push([now, this.dat.cadp / 10]);
            this.pressOption.series[0].data.shift();
            this.pressOption.series[0].data.push([now, this.dat.cap / 10]);
            switch (this.chartType) {
                case 0:
                    this.myChart.setOption(this.tempOption);
                    break;
                case 1:
                    this.myChart.setOption(this.pressOption);
                    break;
            }
        },
        // 切换图表
        changeEchartType(name) {
            this.chartType = name;
            if (this.historyData.isHistory) {
                switch (name) {
                    case 0:
                        this.myChart.setOption(this.tempHistoryOption, { notMerge: true });
                        break;
                    case 1:
                        this.myChart.setOption(this.pressHistoryOption, { notMerge: true });
                        break;
                }
            } else {
                switch (name) {
                    case 0:
                        this.myChart.setOption(this.tempOption, { notMerge: true });
                        break;
                    case 1:
                        this.myChart.setOption(this.pressOption, { notMerge: true });
                        break;
                }
            }
        },
        // 显示修改属性对话框
        showAttrsModal() {
            this.attrsModal.attrs = Object.assign({}, this.attrs);
            this.attrsModal.show = true;
        },
        // 确认修改
        doChangeAttrs() {
            this.attrs = this.attrsModal.attrs;
            sessionStorage.setItem('cadryer_attrs', JSON.stringify(this.attrs));
        },
        //历史数据 1小时 6小时 1天 切换按钮
        histortBtn(range) {
            this.historyData.btnValue = range;
            if (range == 0) {
                this.historyData.end = '';
                this.historyData.start = '';
            } else {
                this.historyData.end = Moment().format('YYYY-MM-DD HH:mm:ss');
                this.historyData.start = Moment()
                    .subtract(range, 'hours')
                    .format('YYYY-MM-DD HH:mm:ss');
            }
        },
        //修改开始时间  结束时间
        changeHistoryDate(date, tag) {
            this.historyData[tag] = date;
            this.historyData.isHistory = true;
            this.historyData.btnValue = -1;
        },
        //点击确定按钮查询历史数据
        historySubmit() {
            let { start, end, btnValue } = this.historyData;
            if (btnValue == 0) {
                this.historyData.isHistory = false;
                this.getRealTime();
                this.historyData.inputData = Moment().format('YYYY-MM-DD HH:mm:ss');
                this.datIntval = setInterval(() => {
                    this.historyData.inputData = Moment().format('YYYY-MM-DD HH:mm:ss');
                    this.getRealTime();
                }, 3000);
                this.historyData.showPoptip = false;
                return;
            }
            if (start == '' || end == '') {
                this.$Message.warning(this.$t('b_timeRangeEmpty'));
                return;
            } else if (Moment(end).unix() <= Moment(start).unix()) {
                this.$Message.warning(this.$t('b_endBeforeStart'));
                return;
            } else if (Moment(end).unix() - Moment(start).unix() > 30 * 24 * 60 * 60) {
                this.$Message.warning(this.$t('b_only30Days'));
                return;
            } else if (Moment(end).unix() - Moment(start).unix() > 24 * 60 * 60) {
                this.$Message.warning(this.$t('b_rangeMore1Day'));
                return;
            }
            this.historyData.inputData = `${Moment(start).format('YYYY-MM-DD HH:mm:ss')} -- ${Moment(end).format('YYYY-MM-DD HH:mm:ss')}`;
            this.historyData.isHistory = true;
            this.historyData.showPoptip = false;
            Axios.get(AxiosUrl.device.historydata, {
                params: { start, end, serial: this.device.uuid, kind: this.device.kind }
            }).then(res => {
                if (res.data.code == 200) {
                    //把定时器关闭
                    clearInterval(this.datIntval);
                    let data = res.data.data;
                    this.tempHistoryOption.series[0].data = [];
                    this.tempHistoryOption.series[1].data = [];
                    this.tempHistoryOption.series[2].data = [];
                    this.tempHistoryOption.series[3].data = [];
                    this.tempHistoryOption.series[4].data = [];
                    this.tempHistoryOption.xAxis.data = [];
                    this.pressHistoryOption.series[0].data = [];
                    this.pressHistoryOption.xAxis.data = [];
                    for (let { sv, pv, back, dp, cadp, cap, time } of data) {
                        time = Moment(time).format('HH:mm:ss');
                        this.tempHistoryOption.series[0].data.push(sv / 10);
                        this.tempHistoryOption.series[1].data.push(pv / 10);
                        this.tempHistoryOption.series[2].data.push(back / 10);
                        this.tempHistoryOption.series[3].data.push(dp / 10);
                        this.tempHistoryOption.series[4].data.push(cadp / 10);
                        this.tempHistoryOption.xAxis.data.push(time);
                        this.pressHistoryOption.series[0].data.push(cap / 10);
                        this.pressHistoryOption.xAxis.data.push(time);
                    }
                    switch (this.chartType) {
                        case 0:
                            this.myChart.setOption(this.tempHistoryOption, { notMerge: true });
                            break;
                        case 1:
                            this.myChart.setOption(this.pressHistoryOption, { notMerge: true });
                            break;
                    }
                } else {
                    console.log(res.data.msg);
                }
            });
        }
    }
};
</script>
<style lang="less">
// .cadryer-main {
//     margin-top: -35px;
// }
</style>



// WEBPACK FOOTER //
// src/views/group/components/cadryer.vue